import { memo, useContext } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Zap } from 'lucide-react'
import { ExecutionContext } from '../../../components/flow-nodes/shared/ExecutionContext'

// Handle 样式常量
const HANDLE_STYLE_GREEN = {
  width: 12,
  height: 12,
  background: '#22c55e',
  border: '2px solid #16a34a',
} as const

// 自定义节点组件：入口节点
export const EntryNode = memo(({ data, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)
  
  return (
    <div className={`px-4 py-2 shadow-md rounded-full bg-green-500 text-white border-2 border-green-600 transition-all duration-300 ${
      isActive ? 'ring-4 ring-green-400/50 animate-pulse scale-105' : ''
    } ${isVisited && !isActive ? 'ring-2 ring-green-300/50' : ''}`}>
      <div className="flex items-center gap-2">
        <Zap className="h-4 w-4" />
        <span className="font-medium text-sm">{data.label}</span>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        style={HANDLE_STYLE_GREEN}
      />
    </div>
  )
})

EntryNode.displayName = 'EntryNode'